import { rawTransform } from 'src/services/skuit/utils'

import { ShipstationOrder } from 'src/api/models'

import { API, CustomAxiosConfig } from '../types'

class ParcelOrderAPI {
  api: API

  constructor(api: API) {
    this.api = api
  }

  retrieve = async (guid: string, config: CustomAxiosConfig = {}): Promise<ShipstationOrder> => {
    const response = await this.api.get(`/shipping/asn/${guid}`, config)
    return rawTransform(ShipstationOrder)(response.data)
  }

  syncTo = async (guid: string, config: CustomAxiosConfig = {}): Promise<null> => {
    await this.api.post(`/integrations/shipstation/parcel/orders/${guid}/sync-to`, null, config)
    return null
  }

  syncFrom = async (guid: string, config: CustomAxiosConfig = {}): Promise<null> => {
    await this.api.post(`/integrations/shipstation/parcel/orders/${guid}/sync-from`, null, config)
    return null
  }
}

class ShipstationOrderAPI {
  api: API

  constructor(api: API) {
    this.api = api
  }

  retrieve = async (guid: string, config: CustomAxiosConfig = {}): Promise<ShipstationOrder> => {
    const response = await this.api.get(`/integrations/shipstation/parcel/orders/${guid}`, config)
    return rawTransform(ShipstationOrder)(response.data)
  }
}

class ParcelAPI {
  api: API

  constructor(api: API) {
    this.api = api
  }

  get orders() {
    const api = new ParcelOrderAPI(this.api)
    Object.defineProperty(this, 'orders', { value: api })
    return api
  }
}

export class ShipstationAPI {
  api: API

  constructor(api: API) {
    this.api = api
  }

  get orders() {
    const api = new ShipstationOrderAPI(this.api)
    Object.defineProperty(this, 'orders', { value: api })
    return api
  }

  get parcel() {
    const api = new ParcelAPI(this.api)
    Object.defineProperty(this, 'parcel', { value: api })
    return api
  }
}
